import {
  Box,
  Container,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import BaseButton from '../common/BaseButton';
import LayoutStatusPageNavbar from './LayoutStatusPageNavbar';
import { useTranslation } from 'react-i18next';
const ImageRabbit = styled('img')(({ theme }) => ({
  width: '365px',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    width: '200px',
  },
}));

const LayoutStatusPageText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontSize: theme.spacing(5),
  lineHeight: 2,
  width: '100%',
  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(3.5),
  },
}));

const LayoutStatusPageTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(12),
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(4),
  },
}));

const LayoutStatusPageBox = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.mode === 'dark' ? '#222' : '#F9FCFF',
}));
const LayoutStatusPage = ({
  imgUrl = '',
  title = '',
  text = '',
  secondText = '',
  routerBack = '',
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <LayoutStatusPageBox>
      <LayoutStatusPageNavbar />
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <ImageRabbit src={`/static/img/${imgUrl}`} />
          <LayoutStatusPageTitle>{title}</LayoutStatusPageTitle>
          <LayoutStatusPageText>{text}</LayoutStatusPageText>
          <LayoutStatusPageText sx={{ mb: 10 }}>
            {secondText}
          </LayoutStatusPageText>
          {routerBack ? (
            <BaseButton
              sx={{ px: smDown ? 20 : 30 }}
              link
              to={routerBack}
              variant="outlined"
            >
              {t('button_text.back_home')}
            </BaseButton>
          ) : null}
        </Box>
      </Container>
    </LayoutStatusPageBox>
  );
};
export default LayoutStatusPage;
